import { useTranslation } from 'next-i18next'
import toast from 'react-hot-toast'
import { MAX_UPLOAD_FILES } from 'shared/constants'

export const useMultipleFileUpload = (): {
  handleMultipleFileUpload: (
    files: File[],
    onUpload: (file: File) => Promise<void>,
  ) => Promise<void>
} => {
  const { t } = useTranslation()

  const handleMultipleFileUpload = async (
    files: File[],
    onUpload: (file: File) => Promise<void>,
  ): Promise<void> => {
    let filesToUpload = files

    if (files.length > MAX_UPLOAD_FILES) {
      toast.error(
        t('post.attachments.file_upload.max_files_exceeded', {
          max: MAX_UPLOAD_FILES,
        }),
      )
      filesToUpload = files.slice(0, MAX_UPLOAD_FILES)
    }

    await Promise.all(filesToUpload.map(file => onUpload(file)))
  }

  return { handleMultipleFileUpload }
}
